import React from "react";

const RealSingleCrochetShape = (props) => {
  return (
    <div style={{ width: props.size, height: props.size }}>
      <div
        style={{
          width: props.size,
          height: props.size,
          backgroundSize: "cover",

          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          // backgroundColor: "rgba(255, 0, 0, 0.5)",
          backgroundImage: "url('/shape_sc.png')",
          backgroundColor: props.color,
          // border: "1px solid grey",
          boxSizing: "border-box",
        }}
      ></div>
    </div>
  );
};

export default RealSingleCrochetShape;
